// REDESIGN 2024

import { isMobile } from '../utils/viewport';
import { handleWrapperSpacings } from './navigation';
import { navigationElement } from './navigationElements';

export const dynamicNavigation = (template: HTMLTemplateElement) => {
  // Vytvořit message
  let dynamicNav = template.content.firstElementChild?.cloneNode(true) as HTMLDivElement;
  dynamicNav.setAttribute('style', '');

  const brandingWrapperElement: HTMLElement | null = document.querySelector('.branding-wrapper');
  const bodyElement = document.querySelector('body');

  // Zjistit výšky element
  const navigationHeight = navigationElement ? navigationElement.clientHeight : 0;

  // Přidat do brandingWrapperElement
  if (isMobile() && brandingWrapperElement) {
    if (!navigationElement?.contains(dynamicNav)) navigationElement?.append(dynamicNav);
  } else {
    // Pokud bodyElement neobsahuje dynamickou navigaci, přidat ji
    if (!bodyElement?.contains(dynamicNav)) bodyElement?.prepend(dynamicNav);

    // Pozicovat fixně pod navigaci
    if (dynamicNav.getAttribute('style')) {
      dynamicNav.style.position = 'fixed';
      dynamicNav.style.top = `${navigationElement?.clientHeight}px`;
      dynamicNav.style.width = `100%`;
    }
  }

  // DOM element navigace (tentokrát už NE z template ale strukturu z DOMu)
  dynamicNav = document.querySelector('[data-dynamic-navigation]') as HTMLDivElement;
  addDynamicNavigationAnimatedBackground();

  const handleScroll = () => {
    // Pokud je viewport mobil (max-width: 767px),
    // dynamickou navigaci dat od horního okraje viewportu až pod spodní okraj navigace
    if (isMobile()) {
      navigationElement?.appendChild(dynamicNav);
      handleWrapperSpacings(navigationElement);

      return;
    }

    handleDesktop({
      dynamicNav,
      navigationHeight,
      brandingWrapperElement,
    });
  };

  // Init
  handleScroll();

  // Přidat listener na scroll
  window.addEventListener('scroll', handleScroll);
};

// Vytvořit pozadí pro dynamickou navigaci (přijede shora při scrollování)
export const addDynamicNavigationAnimatedBackground = () => {
  const dynamicNavBg = document.createElement('div');
  dynamicNavBg.setAttribute('style', '');
  dynamicNavBg.setAttribute('data-dynamic-navigation-bg', '');
  document.body.appendChild(dynamicNavBg);
};

interface HandleDesktopProps {
  dynamicNav: HTMLElement;
  navigationHeight: number;
  brandingWrapperElement: HTMLElement | null;
}

export const handleDesktop = ({
  dynamicNav,
  navigationHeight,
  brandingWrapperElement,
}: HandleDesktopProps) => {
  const CLASS_NAV_WITH_DYNAMIC_NAV = 'body--navigation-with-dynamic-navigation';

  // Pokud je scroll menší než offsetTop dynamické navigace, přesunout dynamickou navigaci pod navigaci a brandingWrapperElement neobsahuje dynamicNav
  if (!brandingWrapperElement?.contains(dynamicNav)) {
    brandingWrapperElement?.prepend(dynamicNav);
  }

  dynamicNav.style.position = 'sticky';
  // Pokud je scroll větší než offsetTop dynamické navigace, přilepit navigaci pod navigaci
  if (dynamicNav.getBoundingClientRect().top <= navigationHeight) {
    dynamicNav.style.top = `${navigationHeight - 1}px`;
    addDynamicNavBg({
      add: true,
      navigationHeight,
      dynamicNav,
    });

    // Inzerce (desktop): Přidat třídu na posun brandingu
    document.body.classList.add(CLASS_NAV_WITH_DYNAMIC_NAV);
  } else {
    // Inzerce (desktop): Odebrat třídu na posun brandingu
    document.body.classList.remove(CLASS_NAV_WITH_DYNAMIC_NAV);
    // Výchozí pozice na desktopu
    // Přilepit navigaci k hornímu okraji hlavního obsahu
    dynamicNav.style.top = '0';

    // Ošetřit padding-top pro brandingWrapperElement
    if (brandingWrapperElement) brandingWrapperElement.style.paddingTop = `0`;

    // Přidat animované pozadí shora - odstínit branding
    addDynamicNavBg({
      add: false,
      navigationHeight,
      dynamicNav,
    });
  }

  resizeUpToWrapper({
    dynamicNav,
    wrapperElement: brandingWrapperElement,
  });
};

// Roztáhnout podle wrapper elementu
interface ResizeUpToWrapperProps {
  dynamicNav: HTMLElement;
  wrapperElement: HTMLElement | null;
}
export const resizeUpToWrapper = ({ dynamicNav, wrapperElement }: ResizeUpToWrapperProps) => {
  // Dynamické navigaci nastavit šířku brandingWrapperu
  dynamicNav.style.width = `${wrapperElement?.clientWidth}px`;

  // Pokud má brandingWrapperElement padding, nastavit odsunu pro dynamickou navigaci
  const paddingOfParent = window.getComputedStyle(wrapperElement as HTMLElement).paddingLeft;

  dynamicNav.style.paddingLeft = `-${paddingOfParent}`;
  if (parseInt(paddingOfParent) > 0) {
    dynamicNav.style.marginLeft = `-${paddingOfParent}`;
  }
};

// Přidat/odebrat 'pozadí shora' pro dynamickou navigaci
interface AddDynamicNavBgProps {
  add: boolean;
  navigationHeight: number;
  dynamicNav: HTMLElement;
}
export const addDynamicNavBg = ({ add, navigationHeight, dynamicNav }: AddDynamicNavBgProps) => {
  const dynamicNavBgElement: HTMLElement | null = document.querySelector(
    '[data-dynamic-navigation-bg]'
  );

  if (dynamicNavBgElement) {
    if (add) {
      dynamicNavBgElement.style.top = `${navigationHeight - 1}px`;
      dynamicNavBgElement.style.zIndex = 'auto';
      dynamicNavBgElement.style.height = `${dynamicNav.clientHeight}px`;
      dynamicNavBgElement.style.width = `100%`;
      dynamicNavBgElement.style.position = 'fixed';
      dynamicNavBgElement.style.transition = 'top 0.3s ease-in-out';
    } else {
      dynamicNavBgElement.style.top = `0`;
    }
  }
};
